export default __webpack_public_path__ + "static/media/spell1.518ecfd5.jpg";